import { getData } from "./index.svc"

export const getMasterboards = async (showAll = false) => {
  const qs = showAll ? '?all=1' : ''
  return await getData(`masterboard${qs}`)
}

export const getMasterboardJobNumbers = async () => {
  return await getData('masterboard/jobNumbers')
}

export const updateWorkflow = async (body) => await getData(`masterboard/workflow/${body.JobNumber}`, 'POST', body)

export const createMasterboard = async (body) => await getData('masterboard', 'POST', body)

export const updateMasterboard = async (body) => await getData(`masterboard/${body.JobNumber}`, 'POST', body)

export const deleteMasterboard = async (body) => await getData(`masterboard/${body.JobNumber}?Active=No`, 'DELETE')

export const restoreMasterboard = async (body) => await getData(`masterboard/${body.JobNumber}?Active=Yes`, 'DELETE')